import { createContext, useContext, useState } from "react";

const CryptoContext = createContext();

export const CryptoProvider = ({ children }) => {
  const [aesKey, setAesKey] = useState(null);

  return (
    <CryptoContext.Provider value={{ aesKey, setAesKey }}>
      {children}
    </CryptoContext.Provider>
  );
};

export const useCrypto = () => useContext(CryptoContext);